import { gql } from '@apollo/client';

export const GET_USERS = gql`
  query GetUsers($input: UserQueryInput!, $trainerId: ID) {
    users(input: $input) {
      _id
      name
      email
      avatarUrl
      workoutSessionCount
      lastWorkoutSessionAt
      workoutActivityStreakCount
      createdAt
      trainingPlanSessions {
        _id
        status
        enrolledAt
        completedAt
        completedEvents {
          eventId
        }
        trainingPlanId
        trainingPlan {
          _id
          title
          eventCount
          weekCount
        }
      }
      subscriptions(trainerId: $trainerId) {
        _id
        vendor
        vendorSubscriptionId
        expiresAt
        trainerId
      }
    }

    trainer(id: $trainerId) {
      totalUserCount
    }
  }
`;

export const INVITE_USER = gql`
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input) {
      message
    }
  }
`;
